module.exports = __webpack_public_path__ + "img/precipitation.124bd0f0.png";